import React from 'react';
import { Table, Empty, Tooltip ,Tag,Button} from 'antd';
import global from '../../../../common/utility/global';

export default function DetalleAnexo(props) {
    return (
        <div>   
            <Table
          
          style={{ overflowX: 'auto' }}

          loading={
              props.pagination.loading ? {
                  tip: "Un momento por favor",
                  size: "large"
              } : false
          }
          size="small"
          rowKey='id'
          dataSource={props.pagination.data}
          onChange={(pagination, filters, sorter) => {
              props.onChange({
                  page: pagination.current,
                  order: sorter.order,
                  field: sorter.field
              })
          }}

          
          locale={{
              emptyText: <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="No se encontraron datos."
              />
          }}
          pagination={{
              total: props.pagination.total,
              current: props.pagination.page,
              pageSize: props.pagination.pageSize,
              showTotal: (total) => `${total} Registro(s) encontrado(s).`
          }}
                
                columns={[
                    {
                        title: 'Fecha Comprobante',
                        dataIndex: 'fechaEmision',
                        key: 'fechaEmision',
                        align: 'center'
                    },
                    {
                        title: 'Nro Comprobante',
                        dataIndex: 'nroSerie_correlativo',
                        key: 'nroSerie_correlativo'
                    },
                    {
                        title: 'Tipo Comprobante',
                        dataIndex: 'comprobante',
                        key: 'comprobante',
                        align: 'center'
                    },
               
        
                    {
                        title: 'Tipo Documento',
                        dataIndex: 'tipoDocumento',
                        key: 'tipoDocumento',
                        align: 'center',

                    },
                    {
                        title: 'Nro Documento',
                        dataIndex: 'nroCliente',
                        key: 'nroCliente',
                        align: 'center',

                    },
                 
                    {
                        title: 'Cliente',
                        dataIndex: 'cliente',
                        key: 'cliente',
                        align: 'center',

                    },
                    {
                        title: 'Cuota',
                        dataIndex: 'cuota',
                        key: 'cuota',
                        align: 'center',

                    },
           
                    {
                        title: 'Moneda Original',
                        dataIndex: 'moneda',
                        key: 'moneda',
                        align: 'center',

                    },

                    {
                        title: 'Pago',
                        className: 'parent-group parent-group-2',
                        children: [
                            {
                                title: 'Soles',
                                dataIndex: 'totalSoles',
                                key: 'totalSoles',
                                className: 'parent-group parent-group-2',

                                align: 'right',
                                render: (data) => (
                                    <span>{data.toFixed(2)}</span>
                                )
                            },
                            {
                                title: 'Dólares',
                                dataIndex: 'totalDolares',
                                key: 'totalDolares',
                                className: 'parent-group parent-group-2',

                                align: 'right',
                                render: (data) => (
                                    <span>{data.toFixed(2)}</span>
                                )
                            }
                        ]
                    },
                    
                    {
                        title: 'Tipo Cambio',
                        dataIndex: 'tipoCambio',
                        key: 'tipoCambio',
                        align: 'center',
                        render: (value) => (
                            <span>{global.decimalFormat(value.toFixed(3))}</span>
                        )
                    },

                    {
                        title: 'Metodo de Pago',
                        dataIndex: 'metodoPago',
                        key: 'metodoPago',
                        align: 'center',

                    },
            
                ]}
            />
        </div>
    );
}